import { createClient } from "@supabase/supabase-js";
import type { Database } from "@synkro/db";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  throw new Error(
    "Faltan VITE_SUPABASE_URL o VITE_SUPABASE_PUBLISHABLE_KEY. " +
      "Copia .env.example a .env.local y completa los valores publicos del proyecto.",
  );
}

/**
 * Cliente unico del panel. Usa la llave publicable, que viaja al navegador:
 * todo el aislamiento lo hace RLS en PostgreSQL, no este archivo.
 *
 * Ningun componente lo importa directamente. Se accede desde la capa `api/`
 * de cada feature, que es la unica que conoce la forma de las consultas.
 */
export const supabase = createClient<Database>(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
